"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _iconWarning = _interopRequireDefault(require("../../icons/icon-warning.svg"));
var _mediaQuery = _interopRequireDefault(require("../../styles/media-query"));
const Well = _styled.default.div(_ref => {
  let {
    theme,
    noWrap
  } = _ref;
  return (0, _mediaQuery.default)({
    backgroundColor: theme.colors.grey[200],
    borderRadius: '5px',
    display: 'flex',
    flexWrap: [noWrap ? 'noWrap' : 'wrap', null, null, 'nowrap'],
    justifyContent: 'center',
    padding: '28px'
  });
});
const Message = _styled.default.div(_ref2 => {
  let {
    theme
  } = _ref2;
  return {
    color: theme.colors.textPrimary,
    width: '100%'
  };
});

/**
 * A component that will display a message inside a light grey background next to a warning icon.
 */
const InfoMessage = _ref3 => {
  let {
    children,
    icon
  } = _ref3;
  return /*#__PURE__*/_react.default.createElement(Well, {
    noWrap: !!icon
  }, icon ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, icon) : /*#__PURE__*/_react.default.createElement("img", {
    alt: "Warning Icon",
    src: icon || _iconWarning.default
  }), /*#__PURE__*/_react.default.createElement(Message, null, children));
};
var _default = exports.default = InfoMessage;